// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"921f96bc","453":"593125b2","934":"f73abb26"}[chunkId] + ".chunk.js";
};